import { render, staticRenderFns } from "./UserPicker.vue?vue&type=template&id=03dd5a12&"
import script from "./UserPicker.vue?vue&type=script&lang=ts&"
export * from "./UserPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports